import { api } from '@upryzze/services';

// Monthly content-refresh drafts (doc 28 W16). Full Service tenants get their
// plan's monthly blog drafts staged here; the AI Writer loads, edits and
// publishes them through the normal content-editor path.

export const listContentRefreshDrafts = () =>
  api.get('/v2/content-refresh').then((r) => r.data);

export const getContentRefreshDraft = (id) =>
  api.get(`/v2/content-refresh/${encodeURIComponent(id)}`).then((r) => r.data);

export const markContentRefreshPublished = (id, path) =>
  api
    .post(`/v2/content-refresh/${encodeURIComponent(id)}/published`, { path })
    .then((r) => r.data);

export const dismissContentRefreshDraft = (id) =>
  api
    .post(`/v2/content-refresh/${encodeURIComponent(id)}/dismiss`)
    .then((r) => r.data);
